import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useCallback } from 'react';
import { PowerPlayerBolt } from '../assets/powerPlayerBolt';
import { ExpandableSection } from '../components/expandableSection';
import { GrowingAmountDisplay } from '../components/growingAmountDisplay';
import { IconWithLabelDisplay } from '../components/iconWithLabelDisplay';
import { useSocketSend } from '../context/webSocket/webSocketContext';
import { InfoIcon } from '../icons/infoIcon';
import { PANEL_ITEM_PADDING_CSS } from '../panels/panelItem';
import { PanelItemDivider } from '../panels/panelItemDivider';
import { thunkGoToGameGuidePage } from '../redux/actions/gameGuideActions';
import { thunkShowPlayerInfo } from '../redux/actions/playerInfoActions';
import { useAppDispatch } from '../redux/store';
import { DRAWER_EXPANDABLE_SECTION_HEADER_COLOR } from '../styles/colors';
import { BAD_BEAT_JACKPOT_AMOUNT_BASE_CSS } from '../types/badBeatJackpotTypes';
const JACKPOT_SECTION_CSS = css(PANEL_ITEM_PADDING_CSS, css `
    display: flex;
    flex-direction: column;
  `);
const SECTION_VALUE_CSS = css `
  align-self: flex-end;
`;
const POWER_PLAYER_JACKPOT_AMOUNT_CSS = css(SECTION_VALUE_CSS, css `
    font-size: 125%;
  `);
const LAST_WINNER_SECTION = css(JACKPOT_SECTION_CSS, css `
    margin-bottom: 15px;
  `);
const CHIPS_LABEL_CSS = css `
  color: #aaa;
`;
const AMOUNT_CSS = BAD_BEAT_JACKPOT_AMOUNT_BASE_CSS;
export const BadBeatJackpotExpandableDrawerSection = ({ badBeatJackpotProperties, closeDrawer }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const onClickInfo = useCallback(() => {
        closeDrawer();
        dispatch(thunkGoToGameGuidePage('bad-beat-jackpot'));
    }, [closeDrawer, dispatch]);
    const onClickLastWinner = useCallback(() => {
        if (!badBeatJackpotProperties.lastWinner) {
            return;
        }
        closeDrawer();
        dispatch(thunkShowPlayerInfo(badBeatJackpotProperties.lastWinner, socketSend));
    }, [badBeatJackpotProperties.lastWinner, closeDrawer, dispatch, socketSend]);
    const { powerPlayerWinnableAmount, nonPowerPlayerWinnableAmount, lastWinner } = badBeatJackpotProperties;
    return (_jsxs(ExpandableSection, { expandableSectionType: 'drawer-bad-beat-jackpot', colorType: 'drawer', children: [_jsxs(Typography, { component: 'div', css: JACKPOT_SECTION_CSS, children: [_jsx("div", { "aria-hidden": true, children: _jsx(IconWithLabelDisplay, { icon: _jsx(PowerPlayerBolt, { color: 'yellow' }), label: 'Power Player' }) }), _jsxs(Typography, { "aria-label": 'Power Player Jackpot Amount', component: 'div', css: POWER_PLAYER_JACKPOT_AMOUNT_CSS, children: [_jsx("span", { css: AMOUNT_CSS, children: _jsx(GrowingAmountDisplay, { amount: powerPlayerWinnableAmount }) }), ' ', _jsx(Typography, { component: 'span', css: CHIPS_LABEL_CSS, children: "Chips" })] })] }), _jsx(PanelItemDivider, { marginPx: 0, thicknessPx: 2, color: DRAWER_EXPANDABLE_SECTION_HEADER_COLOR }), _jsxs(Typography, { component: 'div', css: JACKPOT_SECTION_CSS, children: [_jsx("div", { "aria-hidden": true, children: "Non-Power Player" }), _jsxs(Typography, { "aria-label": 'Non-Power Player Jackpot Amount', component: 'div', css: SECTION_VALUE_CSS, children: [_jsx("span", { css: AMOUNT_CSS, children: _jsx(GrowingAmountDisplay, { amount: nonPowerPlayerWinnableAmount }) }), ' ', _jsx(Typography, { component: 'span', css: CHIPS_LABEL_CSS, children: "Chips" })] })] }), lastWinner ? (_jsxs(_Fragment, { children: [_jsx(PanelItemDivider, { marginPx: 0, thicknessPx: 2, color: DRAWER_EXPANDABLE_SECTION_HEADER_COLOR }), _jsxs(Typography, { component: 'div', css: LAST_WINNER_SECTION, children: [_jsx("div", { "aria-hidden": true, children: "Last Winner" }), _jsx(Button, { variant: 'outlined', size: 'small', onClick: onClickLastWinner, children: lastWinner.name })] })] })) : null, _jsx(Button, { variant: 'outlined', size: 'small', onClick: onClickInfo, startIcon: _jsx(InfoIcon, {}), children: "Jackpot Info" })] }));
};
